import { generatePath } from 'react-router';
import { RerequisitionType } from '@customTypes/requisition';

// Route Paths
// ----------------------------------------------------------------------------
export const ROUTE_PATHS = {
  // Unauthenticated
  ROOT: '/',
  LOGIN: '/login',
  SIGNUP: '/signup',
  // Errors
  ERROR: '/error',
  SESSION_EXPIRED: '/session-expired',
  // Account
  ACCOUNT_REVIEW: '/account-review',
  MANAGE_USERS: '/manage-users',
  MY_DELEGATES: '/my-delegates',
  // Consents
  CONSENTS: '/consents',
  // Requisitions
  REQUISITION_LIST: '/requisitions',
  REQUISITION_CREATE: '/requisitions/create',
  REQUISITION_SUBMITTED: '/requisitions/complete',
  // Drafts
  DRAFT_REQUISITION_LIST: '/draft-orders',
  DRAFT_REQUISITION_DETAILS: '/draft-orders/:draftRequisitionId',
  // Patients
  PATIENT_ROOT: '/patients',
  PATIENT_DETAILS: '/patients/:patientId',
  PATIENT_ORDER_NEW_REPORT: '/patients/:patientId/order-new-report/:requisitionId',
  PATIENT_ORDER_REANALYSIS: '/patients/:patientId/order-reanalysis/:requisitionId',
  PATIENT_ORDER_METHYLATION_REANALYSIS: '/patients/:patientId/order-methylation-reanalysis/:requisitionId',
} as const;

export const PREVENT_ERROR_PAGE_REDIRECT_ROUTES: RoutePath[] = [
  ROUTE_PATHS.CONSENTS,
  ROUTE_PATHS.DRAFT_REQUISITION_DETAILS,
  ROUTE_PATHS.DRAFT_REQUISITION_LIST,
  ROUTE_PATHS.MANAGE_USERS,
  ROUTE_PATHS.MY_DELEGATES,
  ROUTE_PATHS.PATIENT_DETAILS,
  ROUTE_PATHS.PATIENT_ORDER_METHYLATION_REANALYSIS,
  ROUTE_PATHS.PATIENT_ORDER_NEW_REPORT,
  ROUTE_PATHS.PATIENT_ORDER_REANALYSIS,
  ROUTE_PATHS.REQUISITION_CREATE,
  ROUTE_PATHS.REQUISITION_LIST,
  ROUTE_PATHS.SIGNUP,
];

// Route Path Types
// ----------------------------------------------------------------------------
export type RoutePath = EnumObjectValues<typeof ROUTE_PATHS>;

export type PatientDetailsPathParams = Record<'patientId', string>;

export type PatientRerequisitionPathParams = PatientDetailsPathParams & Record<'requisitionId', string>;

export type DraftRequisitionDetailsPathParams = Record<'draftRequisitionId', string>;

// Route Path Builders
// ----------------------------------------------------------------------------
export const getDraftRequisitionDetailsPath = (draftRequisitionId: string): string =>
  generatePath(ROUTE_PATHS.DRAFT_REQUISITION_DETAILS, { draftRequisitionId });

export const getPatientDetailsPath = (patientId: string): string =>
  generatePath(ROUTE_PATHS.PATIENT_DETAILS, { patientId });

interface CreateRerequisitionPathArgs {
  patientId: string;
  requisitionId: string;
  rerequisitionType: RerequisitionType;
}

export const getCreateRerequisitionPath = (params: CreateRerequisitionPathArgs): string => {
  const { patientId, requisitionId, rerequisitionType } = params;

  let pathName: RoutePath = ROUTE_PATHS.PATIENT_ORDER_NEW_REPORT;

  switch (rerequisitionType) {
    case RerequisitionType.REANALYSIS:
      pathName = ROUTE_PATHS.PATIENT_ORDER_REANALYSIS;
      break;
    case RerequisitionType.METHYLATION_REFLEX:
      pathName = ROUTE_PATHS.PATIENT_ORDER_METHYLATION_REANALYSIS;
      break;
  }

  return generatePath(pathName, {
    patientId,
    requisitionId,
  });
};
